module.exports = __webpack_public_path__ + "img/crystal@2x.8dcf8a3.webp";